import OrdersTable from "./OrdersTable";

const GitOrder = () => {
  return <OrdersTable type="git" />;
};

export default GitOrder;
